/**
 * wql
 * @description 路径路径管理
 * @Date  2020/8/13
 */
import React from "react";
import { connect } from "dva";
import { templateConfig, reduxTemplateCofig } from "./config";
import { handleExportHeader } from '@/utils/handleTabelHeaderUtils';

import { component_tool, framework_tool } from '../../../../tool';
let { WizContainer, WizReduxTemplate } = framework_tool;
let { WizBrowserExport,WizModal } = component_tool;


class TrainPathList extends WizContainer {
  componentName = 'trainPathList';
  constructor(props) {
    super(props);
    const {history} = props
    let pathname = '/trainPath'
    if (history.location && history.location.pathname && history.location.pathname.startsWith('/perm/trainPathPerm')) {
      pathname = '/perm/trainPathPerm'
    }
    this.state = {
    }
    this.pathname = pathname

  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }


  _exportTrainPathInfo(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      let headList = o.data['headList']
      let dataList = o.data['dataList']
      WizBrowserExport({
        title: '路径信息',
        sheetName: '路径信息',
        columns: handleExportHeader(headList).filter((_, index) => index),
        rows: dataList,
        filename: '路径信息.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _getPathContent(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      let title = o.data.title
      let dataList = o.data['dataList']
      // let headList = o.data['headList']
      let columnDefs = [
        {
          headerName: '',
          width: 30,
          field: 'rowIndex',
          hidden: true,
          suppressMovable: true,
          cellStyle: {
            textAlign: 'left',
            padding: '5px 0',
            color: '#666666',
            backgroundColor: '#f0f0f0',
            display: 'inline-flex',
            alignItems: 'left',
            justifyContent: 'left',
            fontWeight: '500',
            boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
          },
        },
        {
          headerName: '路径名称',
          field: 'name',
          width: 12,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: { vertical: 'bottom', horizontal: 'left' },
          },
        },
        {
          headerName: '必修范围',
          field: 'requiredTargetScopeName',
          width: 12,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: { vertical: 'bottom', horizontal: 'left' },
          },
        },
        {
          headerName: '选修范围',
          field: 'electiveTargetScopeName',
          width: 12,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: { vertical: 'bottom', horizontal: 'left' },
          },
        },
        {
          headerName: '路径状态',
          field: 'state',
          width: 12,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: { vertical: 'bottom', horizontal: 'left' },
          },
        },
        {
          headerName: '路径阶段有效阶段',
          field: 'num',
          width: 12,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: { vertical: 'bottom', horizontal: 'left' },
          },
        },
        {
          headerName: '阶段名称',
          field: 'stageName',
          width: 12,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: { vertical: 'bottom', horizontal: 'left' },
          },
        },
        {
          headerName: '阶段类型',
          field: 'type',
          width: 12,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: { vertical: 'bottom', horizontal: 'left' },
          },
        },
        {
          headerName: '阶段学习方式',
          field: 'learningStyle',
          width: 15,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: { vertical: 'bottom', horizontal: 'left' },
          },
        },
        {
          headerName: '阶段状态',
          field: 'stageState',
          width: 12,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: { vertical: 'bottom', horizontal: 'left' },
          },
        },
        {
          headerName: '任务名称',
          field: 'taskName',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: { vertical: 'bottom', horizontal: 'left' },
          },
        },
        {
          headerName: '任务类型',
          field: 'taskType',
          width: 12,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: { vertical: 'bottom', horizontal: 'left' },
          },
        },
        {
          headerName: '任务内容',
          field: 'taskContent',
          width: 30,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: { vertical: 'bottom', horizontal: 'left' },
          },
        },
        {
          headerName: '任务学习方式',
          field: 'taskLearningStyle',
          width: 18,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: { vertical: 'bottom', horizontal: 'left' },
          },
        },
        {
          headerName: '任务状态',
          field: 'taskState',
          width: 12,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: { vertical: 'bottom', horizontal: 'left' },
          },
        },
        {
          headerName: '课程名称',
          field: 'programName',
          width: 30,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: { vertical: 'bottom', horizontal: 'left' },
          },
        },
        {
          headerName: '课程编码',
          field: 'scoId',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: { vertical: 'bottom', horizontal: 'left' },
          },
        },
      ]
      WizBrowserExport({
        title: title,
        sheetName: '路径内容',
        columns: columnDefs.filter((_, index) => index),
        rows: dataList,
        filename: '路径内容.xlsx',
        titleParams: {
          alignment: {vertical: 'bottom', horizontal: 'left', wrapText: true},
          style: {
            alignment: {vertical: "bottom", horizontal: "left", wrapText: true},
          },
          font: {},
        },
        titleRow: {
          height: 100
        }
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }



  _render() {
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: templateConfig({pathname: this.pathname}),
      apiDataFormat: {
        enable: this._handleCMD,
        exportTrainPathInfo: this._exportTrainPathInfo,
        getPathContent:this._getPathContent,
        del: this._handleCMD,
        updateState: (nextProps, nextState, key) =>{
          let o = nextProps[key]
          if (o['success']) {
            wizNotice.success(o['msg']);
            let bizIds = o['data']
            if(bizIds){
              if(bizIds>0){

              WizModal.confirm({
                title: '注意', content:"消息通知内容有变更，是否重新发送消息通知",cancelText:"否",okText:"是",
                onOk: () => {
                  this.doAction({
                    path:  "notice/sendNotice",
                    payload: {
                      key: "sendNoticeKey",
                      apiParams: {
                        bizId: bizIds,
                        bizType: 12,
                        resend:true
                      },
                    },
                  })
                },
                onCancel: () => {
                  this.doActions([
                    {
                      path:  "notice/sendNotice",
                      payload: {
                        key: "sendNoticeKey",
                        apiParams: {
                          bizId: bizIds,
                          bizType: 12,
                          resend:false
                        },
                      },
                    },
                  ]);
                }
              });
            }else{

              this.doActions([
                {
                  path:  "notice/sendNotice",
                  payload: {
                    key: "sendNoticeKey",
                    apiParams: {
                      bizId: 0-bizIds,
                      bizType: 12,
                      resend:false
                    },
                  },
                },
              ]);
            }
            }
            return true;
          } else {
            wizNotice.error(o['msg']);
            return false;
          }
        },
      },
    })
    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(TrainPathList);
